const { REACT_APP_BUILD_ENVIRONMENT } = process.env

const config = {
  staging: {
    accountSiteUrl: 'https://staging-account.campgladiator.com',
    amplitudeApiKey: '065b279f7e8e4a97e95cf1c17a372d52',
    realmApiUrl: 'https://staging-realm.campgladiator.com',
    contactUsUrl: 'https://campgladiator.com/contact',
    pricingUrl: 'https://staging-account.campgladiator.com/#/pricing/',
    onlinePlatformApi: 'https://staging.workout-library.api.campgladiator.com',
    trainerServiceApi: 'https://staging.trainer-service.api.campgladiator.com',
    defaultTrainerBioHeaderPhoto:
      'https://storage.googleapis.com/stage.wl4cg.com/images/trainer_bio_default_header_photo.jpg',
    workoutsPageSize: 30,
  },
  production: {
    accountSiteUrl: 'https://account.campgladiator.com',
    amplitudeApiKey: '6d4ccdaed1b64ed4cdfab8a5f91bdde9',
    realmApiUrl: 'https://realm.campgladiator.com',
    contactUsUrl: 'https://campgladiator.com/contact',
    pricingUrl: 'https://account.campgladiator.com/#/pricing/',
    onlinePlatformApi: 'https://workout-library.api.campgladiator.com',
    trainerServiceApi: 'https://trainer-service.campgladiator.com',
    defaultTrainerBioHeaderPhoto:
      'https://storage.googleapis.com/stage.wl4cg.com/images/trainer_bio_default_header_photo.jpg',
    workoutsPageSize: 30,
  },
}

const configuration = {
  ...config[REACT_APP_BUILD_ENVIRONMENT],
}

export default configuration
